export enum ToastVariant {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

const toastSchema = {
  text: {
    default: null,
    icon: null,
  },
  background: {
    default: null,
    icon: null,
  },
  border: null,
};

export const toast: Record<ToastVariant, typeof toastSchema> = Object.values(
  ToastVariant,
).reduce(
  (acc, variant) => {
    acc[variant] = toastSchema;
    return acc;
  },
  {} as Record<ToastVariant, typeof toastSchema>,
);
